import React from "react";
import { Box, Grid2, Stack, Typography } from "@mui/material";
import { LuBus, LuContrast, LuUser2 } from "react-icons/lu";
import Tabbase from "../../../../components/common/tab/Tabbase";
import Content from "./Content";
import { useSelector } from "react-redux";

interface IRight {
  headerHeight: string;
}

function Right({ headerHeight }: IRight) {
  const { journey } = useSelector((state: any) => state.booking);

  return (
    <Box
      sx={{
        width: "100%",
        height: `calc(100vh - ${headerHeight} - 16px)`,
        overflow: "auto",
        backgroundColor: "background.paper",
        borderRadius: "10px",
        p: 1,
      }}
    >
      {!!journey ? (
        <>
          <Stack
            gap={1}
            sx={{
              p: 1,
              backgroundColor: "background.default",
              borderRadius: "10px",
            }}
          >
            {/* Top */}
            <Stack direction="row" alignItems="center" gap={2}>
              <Typography>
                <Typography component="span" sx={{ fontWeight: 600 }}>
                  22:30
                </Typography>{" "}
                <Typography component="span" sx={{ fontWeight: 400 }}>
                  (21:30)
                </Typography>
              </Typography>
              <Typography sx={{ fontWeight: 600 }}>14/11/2024</Typography>
              <Typography sx={{ fontWeight: 600 }}>Sài Gòn - Đà Lạt</Typography>
            </Stack>
            {/* Info */}
            <Stack
              gap={1}
              sx={{
                px: 2,
                py: 1,
                borderRadius: "10px",
                backgroundColor: "background.paper",
              }}
            >
              <Stack direction="row" alignItems="center" gap={4}>
                <Stack direction="row" alignItems="center" gap={1}>
                  <LuBus size={20} />
                  <Typography>Limousine 24 phòng đôi</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" gap={1}>
                  <Typography>
                    60F-011.12{" "}
                    <Typography
                      component="span"
                      sx={{ fontWeight: 600, color: "info.main" }}
                    >
                      0937352638
                    </Typography>{" "}
                  </Typography>
                </Stack>
              </Stack>
              <Stack direction="row" alignItems="center" gap={4}>
                <Stack direction="row" alignItems="center" gap={1}>
                  <LuContrast size={20} />
                  <Typography>
                    <Typography component="span">Trần Thanh Triều</Typography>{" "}
                    <Typography
                      component="span"
                      sx={{ fontWeight: 600, color: "info.main" }}
                    >
                      0937352638
                    </Typography>
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" gap={1}>
                  <LuUser2 size={20} />
                  <Typography>
                    <Typography component="span">Huỳnh Long</Typography>{" "}
                    <Typography
                      component="span"
                      sx={{ fontWeight: 600, color: "info.main" }}
                    >
                      0869510771
                    </Typography>
                  </Typography>
                </Stack>
              </Stack>
              {/* Sumary */}
              <Box
                sx={{ py: 1, borderTop: "1px solid", borderColor: "divider" }}
              >
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Stack gap={1}>
                      <Typography>
                        <Typography
                          component="span"
                          sx={{ fontSize: 20, fontWeight: 600 }}
                        >
                          18
                        </Typography>{" "}
                        /24 vé đã bán
                      </Typography>
                      <Stack direction="row" alignItems="center" gap={2}>
                        <Typography>
                          Lên xe{" "}
                          <Typography component="span" sx={{ fontWeight: 600 }}>
                            0/18
                          </Typography>
                        </Typography>
                        <Typography>
                          Đón{" "}
                          <Typography component="span" sx={{ fontWeight: 600 }}>
                            0/15
                          </Typography>
                        </Typography>
                        <Typography>
                          VP{" "}
                          <Typography component="span" sx={{ fontWeight: 600 }}>
                            0/0
                          </Typography>
                        </Typography>
                      </Stack>
                      <Stack direction="row" alignItems="center" gap={2}>
                        <Typography>
                          TC đón{" "}
                          <Typography component="span" sx={{ fontWeight: 600 }}>
                            0/3
                          </Typography>
                        </Typography>
                        <Typography>
                          TC trả{" "}
                          <Typography component="span" sx={{ fontWeight: 600 }}>
                            0/8
                          </Typography>
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 8 }}>
                    <Stack gap={1}>
                      <Stack direction="row" alignItems="center" gap={2}>
                        <Typography>
                          Tổng tiền{" "}
                          <Typography component="span" sx={{ fontWeight: 600 }}>
                            10.450.000 đ
                          </Typography>
                        </Typography>
                        <Typography>
                          Tài xế thu{" "}
                          <Typography component="span" sx={{ fontWeight: 600 }}>
                            750.000 đ
                          </Typography>
                        </Typography>
                        <Typography>
                          Đã thu{" "}
                          <Typography component="span" sx={{ fontWeight: 600 }}>
                            9.700.000 đ
                          </Typography>
                        </Typography>
                      </Stack>
                      <Stack direction="row" alignItems="center" gap={2}>
                        <Typography>
                          Thanh toán{" "}
                          <Typography component="span" sx={{ fontWeight: 600 }}>
                            0
                          </Typography>
                        </Typography>
                      </Stack>
                      <Stack direction="row" alignItems="center" gap={2}>
                        <Typography>
                          Đặt chỗ{" "}
                          <Typography component="span" sx={{ fontWeight: 600 }}>
                            0
                          </Typography>
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid2>
                </Grid2>
              </Box>
            </Stack>
          </Stack>
          <Tabbase
            tabs={[
              { label: "Sơ đồ ghế", value: "1" },
              { label: "Khách hàng", value: "2" },
              { label: "Hàng hóa", value: "3" },
            ]}
            panels={[
              { value: "1", content: <Content /> },
              { value: "2", content: <Content /> },
              { value: "3", content: <Content /> },
            ]}
          />
        </>
      ) : (
        <Typography>Chưa chọn lịch trình</Typography>
      )}
    </Box>
  );
}

export default Right;
